import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import {
  AuthStore,
  BookingPlansLoadingState,
  BookingStore,
  BookingSubscription,
  noInstallationsError,
} from '@store';
import { SubscriptionPlan } from '@vi-iot/client';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { matTooltipSetter } from '../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-commercial-booking-plans',
  templateUrl: './commercial-booking-plans.component.html',
  styleUrls: ['./commercial-booking-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialBookingPlansComponent implements OnInit, OnDestroy {
  BookingPlansLoadingState = BookingPlansLoadingState;
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Output() planSelected = new EventEmitter<void>();
  BookingPlans = SubscriptionPlan;
  subscribedCommercialPackage: BookingSubscription;
  noInstallationsError = noInstallationsError;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(public bookingStore: BookingStore, public authStore: AuthStore) {}

  ngOnInit(): void {
    this.bookingStore.fetchSubscriptionsPlans();
    this.bookingStore.getAllVitoguideSubscriptions();
    this.bookingStore.activeOrCanceledCommercialSubscription$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((commercialPackage) => {
        this.subscribedCommercialPackage = commercialPackage;
      });
  }

  selectPlan(plan: SubscriptionPlan): void {
    this.bookingStore.selectPlan(plan);
    if (
      (plan === SubscriptionPlan.Pro || plan === SubscriptionPlan.Basic) &&
      !this.subscribedCommercialPackage
    ) {
      this.bookingStore.getCommercialPriceDetails(plan);
      this.planSelected.emit();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
